import { DateTime } from 'luxon';

export const toLocaleFormattedDate = (date: Date): string =>
  DateTime.fromJSDate(date).toLocaleString({
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
